/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:28
 * @LastEditors: linxi
 * @LastEditTime: 2024-03-11 15:47:35
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  DatePicker,
  Checkbox,
  Cascader,
} from 'antd'
import { unwatchFile } from 'fs'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectInsuranceArray, selectTenantCountyCode } from '../../../../app/applicationSlice'
import { RootDispatch } from '../../../../app/store'
import { DateTimeFormatSimpleOnlyOne, DateTimeFormatSimple } from '../../../../models/datetime'
import { DateRangeType, DateSelect } from '../../../../compnents/form/DateSelect'
import { getCommonCodeCompletionsAsync } from '../../../completion/completionSlice'
import { CommonCodeCategory } from '../../../../models/commoncode'
import { getMaterialsName, Materiales } from '../../../../models/commodity'


export const Query = (props: {
  onValueChange: (params: any) => void
  loading?: any
}): ReactElement => {
  const [form] = Form.useForm()

  const insuranceArray = useSelector(selectInsuranceArray)

  const dispatch = useDispatch<RootDispatch>()

  const [treeData, setTreeData] = useState<any>([])

  const [dates, setDates] = useState<any>([]);


  useEffect(() => {
    const data = Materiales.map((v) => {
      return {
        id: v,
        value: v.toString(),
        label: getMaterialsName(v),
        children: [],
      }
    })
    dispatch(
      getCommonCodeCompletionsAsync({
        category: CommonCodeCategory.Durg,
        keyword: '',
      })
    )
      .then(unwrapResult)
      .then((res) => {

        const tree = data.map((v) => {
          if (v.id == 0) {
            return {
              ...v,
              children: res.records.map((el: any) => ({
                value: el.codeName,
                label: el.codeName,
              })),
            }
          } else if (v.id == 1) {
            return {
              ...v,
              children: [
                { value: '材料', label: '材料' },
                { value: '器械', label: '器械' },
                { value: '消耗品', label: '消耗品' },
                { value: '其他', label: '其他' },
              ],
            }
          } else if (v.id == 2) {
            return {
              ...v,
              children: [
                { value: '第一类医疗器械', label: '第一类医疗器械' },
                { value: '第二类医疗器械', label: '第二类医疗器械' },
                { value: '第三类医疗器械', label: '第三类医疗器械' },
              ],
            }
          } else if (v.id == 4) {
            return {
              ...v,
              children: [
                { value: '食品', label: '食品' },
                { value: '化妆品', label: '化妆品' },
                { value: '保健品', label: '保健品' },
                { value: '卫生消毒用品', label: '卫生消毒用品' },
                { value: '初级农产品', label: '初级农产品' },
                { value: '其他产品', label: '其他产品' },
              ],
            }
          } else {
            return v
          }
        })

        setTreeData(tree)
      })
  }, [])

  // 处理日期变化的函数
  const onDateChange = (values: any) => {
    setDates(values);
  };

  const disabled31Days = (current: any) => {
    // 限制选择范围不能超过31天
    const tooLate = dates?.[0] && current.diff(dates?.[0], 'days') > 30;
    const tooEarly = dates?.[1] && dates?.[1].diff(current, 'days') > 30;
    return tooEarly || tooLate;
  };

  return (
    <Form
      form={form}
      onFinish={(values) => {
        // const startTime = moment(values.time).startOf('month').format(DateTimeFormatSimpleOnlyOne)
        // const endTime = moment(values.time).endOf('month').format(DateTimeFormatSimpleOnlyOne)
        // if (!startTime) {
        //   return
        // }
        const startTime = moment(values?.timeHead)?.startOf('day').format(
          DateTimeFormatSimpleOnlyOne
        )
        const endTime = moment(values?.timeTail)?.endOf('day').format(
          DateTimeFormatSimpleOnlyOne
        )
        if (!values?.timeHead && values?._dateRange == 6) {
          return
        }
        const category = values?.materialsCategory
        props.onValueChange({
          ...values,
          timeHead: undefined,
          timeTail: undefined,
          startTime: startTime,
          endTime: endTime,
          materialsCategory: undefined,
          drugCategory: Array.isArray(category) ? category?.[0] : undefined,
          category: Array.isArray(category) ? category?.[1] : undefined,
        })
      }}
    >
      <Row style={{ marginLeft: 4, marginBottom: 10 }} justify='space-between'>
        <Space>
          <Form.Item name='materialsCategory' noStyle>
            <Cascader
              options={treeData}
              onChange={form.submit}
              changeOnSelect
              placeholder='商品类别'
            />
          </Form.Item>
          <Form.Item name='insuranceCode' noStyle>
            <Select
              placeholder='结算险种'
              style={{ width: '8.25rem' }}
              allowClear
              onChange={form.submit}
            >
              <Select.Option value={'ZIFEI'}>自费</Select.Option>
              {insuranceArray.map((v) => (
                <Select.Option value={v?.insuranceCode} key={v.insuranceCode}>
                  {v.insuranceName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {/*  <DatePicker
              picker='month'
              allowClear={false}
              onChange={(v: any) => {
                form.submit()
              }}
            />*/}
          <DateSelect
            placeholder='时间'
            namePrefix='time'
            labelPrefix=''
            style={{ width: '8.5rem' }}
            onCalendarChange={((v) => {
              onDateChange(v)
            })}
            onChange={(v) => {
              form.submit()
            }}
            disabledDate={disabled31Days}
            allowClear={false}
            initialValue={DateRangeType.Today}
          />


          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
